// import img502 from './image 502.png';
// import img502 from './image 502.png';
import mIconimg502 from "./image 502.png";
import mIconimg508 from "./image 508.png";
import mIconimg537 from "./image 537.png";
import mIconimg538 from "./image 538.png";
import mIconimg539 from "./image 539.png";
import mIconimg540 from "./image 540.png";
import mIconimg541 from "./image 541.png";
import mIconimg543 from "./image 543.png";
import mIconimg544 from "./image 544.png";
import mIconimg546 from "./image 546.png";

export const materialIcons = {
  mIconimg502,
  mIconimg508,
  mIconimg537,
  mIconimg538,
  mIconimg539,
  mIconimg540,
  mIconimg541,
  mIconimg543,
  mIconimg544,
  mIconimg546,
};

export default materialIcons;
